import { useParams } from "react-router-dom";
import { HistoryModal } from "./modals/history.modal";
import { Address } from "viem";

export default function HistoryPage() {
  const { address } = useParams();

  return (
    <HistoryModal address={address as Address} onDismiss={() => {}} />
  );
}
